import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '@/lib/firebase';
import { useState } from 'react';

export const useGoogleAuth = () => {
  const provider = new GoogleAuthProvider();
  const [idToken, setIdToken] = useState<string>();

  const signUpWithGoogle = () => {
    signInWithPopup(auth, provider)
      .then(async (u) => {
        const idToken = await u.user.getIdToken();
        setIdToken(idToken);
      })
      .catch((e) => {
        // console.log(e);
      });
  };

  return { signUpWithGoogle, idToken };
};
